import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cashierBonusActions from '../../../../store/analyticsStores/cashierBonusStore/cashierBonusActions';
import CashierBonusAnalytics from './CashierBonusAnalytics';
import CashierTransactionDetails from './CashierTransactionDetails';
import { PENDING } from '../../../../store/globalStatuses/globalStatuses';
import { useCurrentBranch } from '../../../../hooks/useCurrentBranch';

function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${year}-${month}-${day}`;
}

export default function CashierBonusAnalyticsContainer() {
    const dispatch = useDispatch();
    const { analytics, status, transactionsData, transactionsStatus } = useSelector(state => state.cashierBonusReducer);
    const { info } = useSelector(state => state.branchReducer);
    const { currentRole, groupId } = useCurrentBranch();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedCashier, setSelectedCashier] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortBy, setSortBy] = useState('created_at');
    const [sortDir, setSortDir] = useState('desc');

    const buildDates = useCallback(() => {
        if (startDate && endDate) {
            return `?from=${formatDate(startDate)}&to=${formatDate(endDate)}`;
        }
        return '';
    }, [startDate, endDate]);

    useEffect(() => {
        if (info?.id) {
            const dates = buildDates();
            if (currentRole === 'analytic' && groupId) {
                dispatch(cashierBonusActions.getGroupCashierBonusAnalytics(groupId, dates));
            } else {
                dispatch(cashierBonusActions.getCashierBonusAnalytics(info.id, dates));
            }
        }
    }, [info?.id, startDate, endDate, currentRole, groupId, dispatch, buildDates]);

    useEffect(() => {
        if (selectedCashier && info?.id) {
            const dates = buildDates();
            if (currentRole === 'analytic' && groupId) {
                dispatch(cashierBonusActions.getGroupCashierTransactions(groupId, selectedCashier.casher_phone, selectedCashier.waiter_id, dates, currentPage, 50, sortBy, sortDir));
            } else {
                dispatch(cashierBonusActions.getCashierTransactions(info.id, selectedCashier.casher_phone, selectedCashier.waiter_id, dates, currentPage, 50, sortBy, sortDir));
            }
        }
    }, [selectedCashier, currentPage, info?.id, currentRole, groupId, dispatch, buildDates, sortBy, sortDir]);

    const handleSelectCashier = (cashier) => {
        setSelectedCashier(cashier);
        setCurrentPage(1);
        setSortBy('created_at');
        setSortDir('desc');
    };

    const handleBack = () => {
        setSelectedCashier(null);
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(field);
            setSortDir('desc');
        }
        setCurrentPage(1);
    };

    if (selectedCashier) {
        return (
            <CashierTransactionDetails
                cashier={selectedCashier}
                transactionsData={transactionsData}
                isLoading={transactionsStatus === PENDING}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onBack={handleBack}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                branchId={info?.id}
                sortBy={sortBy}
                sortDir={sortDir}
                onSort={handleSort}
            />
        );
    }

    return (
        <CashierBonusAnalytics
            analytics={analytics}
            isLoading={status === PENDING}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            branchId={info?.id}
            onSelectCashier={handleSelectCashier}
        />
    );
}
